require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-milan-design-week-space-furniture.json") })
        }
      }, "path---journal-milan-design-week-space-furniture");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-milan-design-week-space-furniture!./.cache/json/journal-milan-design-week-space-furniture.json
// module id = 516
// module chunks = 231608221292675